import { useMemo } from "react"

import { useScreenSize } from "shared/lib/useScreenSize"
import { TableCell } from "shared/ui/table/types"

export enum RoomRowCellType {
  POSITION = "position",
  CLARIFICATION_REQUEST = "clarification-request",
  NAME = "name",
  REMARK = "remark",
  MENU = "menu"
}

export function useRoomRowCells({
  showClarificationRequestColumn,
  columnPreset = "default"
}: {
  showClarificationRequestColumn?: boolean
  columnPreset?: "default" | "selection"
} = {}) {
  const { isTablet } = useScreenSize()

  const cells = useMemo<TableCell[]>(() => {
    const crOffset = showClarificationRequestColumn ? 1 : 0

    if (columnPreset === "selection") {
      return [
        { key: RoomRowCellType.POSITION, colIndex: 1 },
        ...(showClarificationRequestColumn
          ? [{ key: RoomRowCellType.CLARIFICATION_REQUEST, colIndex: 2 }]
          : []),
        {
          key: RoomRowCellType.NAME,
          colIndex: 2 + crOffset,
          colSpan: 1
        }
      ]
    }

    return [
      {
        key: RoomRowCellType.POSITION,
        colIndex: 1
      },
      ...(showClarificationRequestColumn
        ? [
            {
              key: RoomRowCellType.CLARIFICATION_REQUEST,
              colIndex: 2
            }
          ]
        : []),
      {
        key: RoomRowCellType.NAME,
        colIndex: 2 + crOffset,
        colSpan: isTablet ? 5 : 6
      },
      {
        key: RoomRowCellType.REMARK,
        colIndex: (isTablet ? 6 : 7) + crOffset
      },
      ...(!isTablet
        ? [
            {
              key: RoomRowCellType.MENU,
              colIndex: 8 + crOffset
            }
          ]
        : [])
    ]
  }, [isTablet, showClarificationRequestColumn, columnPreset])

  return { cells }
}
